import { ModalShell, showToast } from '@lokalise/louis'
import { useUpdateAiConfigurationMutation } from '@lokalise/shared'
import type { StaticProfileConfig } from '@lokalise/translation-api-schemas'
import { useState } from 'react'
import {
  appHttpClient,
  authenticatedPublicApiHeaderBuilder,
  getTeamIdFromSession,
} from '../../utils/api'
import { showUnexpectedErrorToast } from '../../utils/toast'
import { StepController } from '../StepController/StepController'
import styles from './BaseProfileModal.module.css'
import { BaseProfileBasicsStep } from './components/BaseProfileBasicsStep/BaseProfileBasicsStep'
import { BaseProfileOverviewStep } from './components/BaseProfileOverviewStep/BaseProfileOverviewStep'

type BaseProfileModalProps = {
  profile: StaticProfileConfig
  onClose: () => void
}

export const BaseProfileModal = ({ profile, onClose }: BaseProfileModalProps) => {
  const teamId = getTeamIdFromSession()

  const [stepIndex, setStepIndex] = useState(0)
  const [aiModelIntegration, setAiModelIntegration] = useState(profile.config?.integration)
  const onNext = () => setStepIndex((i) => i + 1)

  const onSuccess = () => {
    showToast({ type: 'success', title: `${profile.name} has been updated` })
    onClose()
  }
  const onError = showUnexpectedErrorToast
  const { mutate: update, isPending: isUpdatingAiConfig } = useUpdateAiConfigurationMutation(
    appHttpClient,
    authenticatedPublicApiHeaderBuilder,
    { onSuccess, onError },
  )

  const onSubmit = () =>
    update({
      teamId,
      configurationId: profile.id,
      name: profile.name,
      is_default: profile.is_default,
      config: {
        integration: aiModelIntegration,
      },
    })

  return (
    <ModalShell className={styles.modal} opened onClose={onClose} title="TM profile assignment">
      <StepController stepIndex={stepIndex}>
        <BaseProfileOverviewStep name={profile.name} onClose={onClose} onNext={onNext} />
        <BaseProfileBasicsStep
          name={profile.name}
          selectedAiModel={aiModelIntegration}
          isLoading={isUpdatingAiConfig}
          onAiModelSelected={setAiModelIntegration}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      </StepController>
    </ModalShell>
  )
}
